<template>
  <div class="container is-max-desktop">
    <Spinner v-if="loading" />
    <div v-else>
      <div class="has-text-centered p-5" v-if="userCompleted">
        <h3>{{ $t('payment.received') }}</h3>
        <h3>{{ $t('common.thanks') }}</h3>
        <a :href="actions.completeUrl" class="button is-medium is-success is-blue">{{ $t('common.continue') }}</a>
      </div>
      <div v-else>
        <h3 class="has-text-centered p-6 review">{{ $t('payment.review') }}</h3>
        <div class="columns box p-0">
          <div class="column description rounded-l has-text-centered p-5">
            <img v-if="$root.isEnneagram" class="cart" src="/img/enneagram/cart.svg" width="150"/>
            <img v-if="$root.isEnneagram" class="circle" src="/img/enneagram/circle.png" width="170" />
            <img v-else :src="`/img/certificate-small-${locale}.png`" width="220" />
            <h2 class="plan-title" v-html="plan.title" />
            <Description :description="plan.description" />
            <div class="is-flex is-justify-content-space-between">
              <h5 class="total">{{ $t('payment.total') }}:</h5>
              <h5 v-if="plan.amount.discount">
                <span v-html="formatPlanTotal"/>
                <span class="line-through ml-2" v-html="formatPlanValue"/>
              </h5>
              <h5 v-else v-html="formatPlanTotal"/>
            </div>
            <p class="is-size-8 has-text-justified" v-if="!$root.isEnneagram">
              {{ $t('payment.description') }}
            </p>
          </div>

          <div class="column rounded-r is-three-fifths choose-method p-5 is-flex is-flex-direction-column">
            <h3 class="has-text-centered has-text-left-tablet" v-html="$t('payment.choose_method')"/>

            <p class="has-text-weight-semibold has-text-centered has-text-left-tablet mb-6">
              {{ $t('payment.incl_vat') }}
              <template v-if="locale === 'en'">
                <a href="https://gimmemore.com/en/terms" target="_blank" class="underline">{{ $t('payment.terms') }}</a> {{ $t('payment.apply') }}.
              </template>
              <template v-else>
                <a :href="`https://gimmemore.com/${locale}/terms`" target="_blank" class="underline">{{ $t('payment.terms') }}</a>.
              </template>
            </p>

            <div class="p-4 white-wrapper has-background-white is-flex-grow-1">
              <DropIn
                :secrets="secrets"
                :payment-methods="paymentMethods"
                :plan="plan"
                :checkout-id="checkoutId"
                :user-country="userCountry"
                :complete-url="actions.completeUrl"
                :return-url="actions.returnUrl"
                :locale="locale"
              />

              <div class="has-text-centered p-5">
                <img class="is-inline" :src="`/img/footer-secure-${locale}.png`"/>
              </div>

              <p class="has-text-centered">
                GimmeMore GmbH<br>
                {{ $t('info.registry') }}: HRB 169612 B Berlin-Charlottenburg
              </p>
            </div>
          </div>
        </div>
        <img v-if="$root.isEnneagram" class="boy" src="/img/enneagram/boy.png" width="170">
        <img v-if="$root.isEnneagram" class="girl" src="/img/enneagram/girl.png" width="170">
      </div>
    </div>
  </div>
</template>

<script>
import vars from '@/vars';
import { functions } from '@/firebase';
import router from '../router';
import DropIn from './DropIn';
import Spinner from "@/components/Spinner";
import Description from "@/components/Description";

export default {
  components: {
    Description,
    Spinner,
    DropIn
  },
  props: {
    checkoutId: { type: String },
    locale: { type: String, default: 'en' },
    secrets: {},
  },
  data() {
    return {
      locales: vars.LOCALES,
      loading: true,
      userCountry: null,
      userCompleted: false,
      paymentMethods: null,
      plan: null,
      actions: null
    }
  },
  computed: {
    formatPlanValue() {
      return this.numberFormatter(this.plan.amount.currency).format(this.plan.amount.value / 100);
    },
    formatPlanTotal() {
      return this.numberFormatter(this.plan.amount.currency).format(this.plan.amount.total / 100);
    },
  },
  methods: {
    numberFormatter(currency) {
      return new Intl.NumberFormat(this.locales[this.locale], {
        style: 'currency',
        currency,
        minimumFractionDigits: 2
      });
    },
    async fetchPaymentRequirements() {
      const response = await functions.httpsCallable('fetchPaymentRequirements')({
        checkoutId: this.checkoutId,
        shopperLocale: this.locales[this.locale]
      });

      this.actions = response.data.actions;

      if (response.data.completed) {
        this.userCompleted = response.data.completed;

        return;
      }

      this.paymentMethods = response.data.paymentMethods;
      this.userCountry = response.data.userCountry;
      this.plan = response.data.plan;
    },
  },
  async mounted() {
    try {
      await this.fetchPaymentRequirements();
    } catch (e) {
      await router.push({ name: 'error' });
    }

    this.loading = false;
  }
}
</script>

<style lang="scss" scoped>
.underline {
  text-decoration: underline;
}

.line-through {
  text-decoration: line-through;
}

.rounded-r {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.rounded-l {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

@media (max-width: 768px) {
  .review {
    background-color: #114F81;
    color: #fff;
    height: 190px;
  }

  .box {
    background-color: #fff;
    box-shadow: none;
    border-radius: 0;
  }

  .white-wrapper {
    padding: 0 !important;
  }

  .choose-method {
    padding: 3rem 2rem 2rem 2rem !important;
  }

  .description {
    background-color: #f5f5f5;
    padding: 3rem !important;

    img {
      margin-top: -135px;
    }
  }
}

@media (min-width: 769px) {
  .description {
    background-color: #114F81;

    p, h2, h5 {
      color: #fff;
    }
  }

  .choose-method {
    background-color: #f5f5f5;
  }
}

.enneagram {
  .description {
    background-color: #36895F;
  }

  @media (max-width: 768px) {
    .circle {
      display: none;
    }

    .plan-title {
      font-size: 1.5em;
      text-align: left;
    }

    .description {
      background-color: #E3DCC6;
      padding: 3rem 2.5rem 1rem !important;
    }

    .review {
      background-color: #E3DCC6;
      color: #363636;
      font-size: 1.75em;
      padding-top: 2rem !important;
    }

    .boy, .girl {
      display: none;
    }
  }

  @media (min-width: 769px) {
    .cart {
      display: none;
    }

    .total {
      font-weight: 400;
    }

    .boy, .girl {
      position: absolute;
      bottom: -48px;
    }

    .boy {
      left: -200px;
    }

    .girl {
      right: -200px;
    }
  }
}
</style>
